"use client";

import React from "react";
import Link from "next/link";
import Slider from "@/components/home/Slider";

const carouselImages = [
  {
    image:
      "/images/photo-bright-dental-treatment-room-with-chair-stool-and-wall-mounted-screen.webp",
    alt: "photo-bright-dental-treatment-room-with-chair-stool-and-wall-mounted-screen",
  },
  {
    image:
      "/images/photo-dental-light-and-wall-mounted-screen-inside-modern-treatment-room.webp",
    alt: "photo-dental-light-and-wall-mounted-screen-inside-modern-treatment-room",
  },
  {
    image:
      "/images/photo-modern-dental-chair-and-equipment-inside-black-and-white-clinic-room.webp",
    alt: "photo-modern-dental-chair-and-equipment-inside-black-and-white-clinic-room",
  },
  {
    image:
      "/images/photo-modern-dental-reception-desk-with-wall-mounted-screen-and-coffee-station.webp",
    alt: "photo-modern-dental-reception-desk-with-wall-mounted-screen-and-coffee-station",
  },
];

const Welcome: React.FC = () => {
  return (
    <div>
      <div className="max-w-4xl mx-auto px-4 sm:px-8 lg:px-12 py-12 lg:py-16">
        <div className="flex flex-col items-center text-center">
          <h2
            className="
              text-4xl md:text-5xl font-bold text-gray-900
              pb-2 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:my-5
              after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
            "
          >
            Comprehensive Dental Care in Astoria, NY
          </h2>
          <p className="text-md md:text-lg leading-relaxed text-gray-700 mb-4">
            At Smile4Me Dental Care, we provide comprehensive dental services
            for families and individuals across Queens, NY. Whether you need a
            routine cleaning, a dental implant, Invisalign clear aligners, or
            an{" "}
            <Link
              href="/services/emergency-treatment/"
              className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
            >
              emergency dentist in Astoria
            </Link>
            , right away, our team is here for you.
          </p>
          <p className="text-md md:text-lg leading-relaxed text-gray-700 mb-4">
            Led by Dr. Iosif Khaimov, our practice combines advanced dental
            technology with a warm, patient-first approach. We also offer
            flexible financing with up to 2 years of no interest, so exceptional
            dental care is never out of reach.
          </p>
          <p className="text-md md:text-lg leading-relaxed text-gray-700">
            Book your appointment today at{" "}
            <Link
              href="/our-office/"
              className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
            >
              our Steinway Street office
            </Link>
            .
          </p>
        </div>
      </div>

      {/* Office photo gallery */}
      <div className="py-8">
        <Slider items={carouselImages} />
      </div>
    </div>
  );
};

export default Welcome;
